import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { Button, Avatar } from 'antd';
import { useContextSelector } from 'use-context-selector';
import useClickOutside from '../../../hooks/useClickOutside';
import useEscapeKey from '../../../hooks/useEscapeKey';
import styled, { css, cx } from '../../../styled';
import LayoutContext from '../../context';
import TopbarContext from '../context';
const User = React.memo(({ className }) => {
    var _a, _b;
    const wrapperMenuUser = React.useRef(null);
    const user = useContextSelector(TopbarContext, context => context.user);
    const opened = useContextSelector(LayoutContext, context => context.userMenu.opened);
    const hasMenu = useContextSelector(LayoutContext, context => context.userMenu.exists);
    const toogleOpened = useContextSelector(LayoutContext, context => context.userMenu.toogleOpened);
    const falseOpened = useContextSelector(LayoutContext, context => context.userMenu.falseOpened);
    const registerContainer = useContextSelector(LayoutContext, context => context.userMenu.registerContainerPortal);
    useClickOutside(wrapperMenuUser, () => hasMenu && falseOpened(), [hasMenu]);
    useEscapeKey(() => hasMenu && falseOpened(), [hasMenu]);
    if (!user) {
        return null;
    }
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ ref: wrapperMenuUser, className: cx(className, { 'hst-topbar-user-active': hasMenu && opened, 'hst-topbar-user-has-menu': hasMenu }) }, { children: [_jsxs("div", Object.assign({ className: 'hst-topbar-user-label' }, { children: [_jsx("div", Object.assign({ className: 'hst-topbar-user-default' }, { children: _jsxs(Button, Object.assign({ className: 'hst-topbar-user-button', icon: _jsx(Avatar, Object.assign({ src: user.avatar }, { children: (_a = user.name) === null || _a === void 0 ? void 0 : _a.charAt(0) })), type: 'text', shape: 'round', onClick: toogleOpened }, { children: [_jsxs("span", Object.assign({ className: 'hst-topbar-user-name' }, { children: [user.name, " ", !!user.isSupport && '(Suporte)'] })), hasMenu && _jsx(CaretDownOutlined, { className: 'hst-topbar-user-menu-arrow' })] })) })), _jsx("div", Object.assign({ className: 'hst-topbar-user-mobile' }, { children: _jsx(Avatar, Object.assign({ src: user.avatar, onClick: toogleOpened }, { children: (_b = user.name) === null || _b === void 0 ? void 0 : _b.charAt(0) })) }))] })), _jsx("div", { ref: registerContainer })] })) }));
});
export default styled(User, { label: 'hst-topbar-user' })(({ theme }) => css `
    position: relative;
    z-index: 1100;
    margin-left: 8px;
    pointer-events: none;

    &.hst-topbar-user-has-menu {
      pointer-events: all;
    }

    & .hst-topbar-user-menu-arrow {
      transition: 0.15s ease-out;
    }

    &.hst-topbar-user-active {
      & .hst-topbar-user-button {
        background-color: rgba(0, 0, 0, 0.05);
      }

      & .hst-topbar-user-menu-arrow {
        transform: rotate(-180deg);
        margin-bottom: 0;
        margin-top: -5px;
      }
    }

    & .hst-topbar-user-default {
      display: none;
      position: relative;

      & .hst-topbar-user-button {
        display: flex;
        gap: 5px;
        align-items: center;
        padding: 10.5px 10.5px 10.5px 6px;

        & .ant-avatar {
          background-color: ${theme.primaryColor};
          text-transform: uppercase;
          cursor: pointer;
          margin-top: 0;
          margin-right: 0;
        }

        & .hst-topbar-user-name {
          max-width: 100px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
          font-size: 16px;
        }

        & .anticon {
          font-size: 12px;
          margin-bottom: -5px;
        }
      }
    }

    ${theme.mediaQuery.up('lg')} {
      & .hst-topbar-user-default {
        display: block;
      }

      & .hst-topbar-user-mobile {
        display: none;
      }
    }
  `);
